import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    minHeight: '100vh',
    overflow: 'hidden'
  },
  sideBar: (props) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    width: props.drawerWidth,
    transition: 'width 0.3s ease',
    height: '100vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    zIndex: theme.zIndex.drawer,
    // —————————————— scrollbar oculto por defecto ——————————————
    // Firefox
    scrollbarWidth: 'none',
    // WebKit
    '&::-webkit-scrollbar': {
      width: 0
    },
    '&:hover': {
      // Firefox
      scrollbarWidth: 'thin',
      scrollbarColor: 'rgba(0,0,0,0.2) transparent',

      // WebKit (Chrome, Edge, Safari)
      '&::-webkit-scrollbar': {
        width: '6px'
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,0.2)',
        borderRadius: '3px'
      }
    }
  }),
  appContent: (props) => ({
    marginLeft: props.drawerWidth,
    display: 'flex',
    flexDirection: 'column',
    width: `calc(100% - ${props.drawerWidth}px)`,
    overflow: 'hidden',
    transition: 'margin-left 0.3s ease, width 0.3s ease'
  }),
  toolbarWrapper: {
    position: 'fixed',
    top: 0,
    transition: 'top .3s ease-in 0s',
    width: '-webkit-fill-available',
    zIndex: theme.zIndex.appBar
  },
  scrollEffectDown: {
    top: -50
  },
  content: {
    flexGrow: 1,
    width: '-webkit-fill-available',
    paddingTop: theme.mixins.toolbar.minHeight,
    padding: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.mixins.toolbar.minHeight,
      padding: theme.spacing(2)
    }
  }
}))

export default useStyles
